/**
 * Sprint 23.8 — SidebarBlock (workspace-home sidebar primitive).
 *
 * One titled section inside the workspace-home `<aside>`. Blocks are separated
 * by a hairline top border (not individual cards) so the sidebar reads as one
 * elevated strip with divided sections — distinct from the agent-profile
 * sidebar, whose blocks are individual cards (intentionally a different, locked
 * treatment; not shared). Title is 10px uppercase tertiary; the first block
 * omits the top border + top padding.
 */

import { type CSSProperties, type ReactNode } from "react";

export interface SidebarBlockProps {
  title: string;
  children: ReactNode;
  /** The first block has no divider above it. */
  isFirst?: boolean;
}

export function SidebarBlock({ title, children, isFirst }: SidebarBlockProps) {
  return (
    <div style={isFirst ? firstWrap : wrap}>
      <h3 style={blockTitle}>{title}</h3>
      {children}
    </div>
  );
}

const firstWrap: CSSProperties = {};

const wrap: CSSProperties = {
  borderTop: "0.5px solid var(--color-border-tertiary)",
  paddingTop: 12,
};

const blockTitle: CSSProperties = {
  margin: "0 0 8px",
  fontSize: 10,
  fontWeight: 500,
  color: "var(--color-text-tertiary)",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};
